import type {
  GrantPersonAccessCommand,
  GrantPersonAccessResult,
} from "@/domain/model/AccountSeatOverview";
import type { AccountManagementService } from "@/domain/port/AccountManagementService";

export class GrantPersonAccess {
  constructor(private readonly service: AccountManagementService) {}

  execute(
    command: GrantPersonAccessCommand,
    signal?: AbortSignal,
  ): Promise<GrantPersonAccessResult> {
    return this.service.grantPersonAccess(command, signal);
  }
}
